// Material
import { List } from '@mui/material'
import { styled } from '@mui/material/styles'
// Common
import { ProfileActionItem } from '$common/profile-action-item'
import { ChatIcon } from '$common/icons'
import { SharedMediaIcon } from '$common/icons/shared-media'
// Helpers
import { toLocale } from '$func/text'
// Localization
import { t } from '$i18n'
import { getWappRoomByWappId } from '$logic/wapp-room'
import { openRoom } from '$logic/opened-room'

const StyledList = styled(List)`
  padding-top: 0;
  padding-bottom: 0;
  background-color: white;
  margin-top: 10px;
`

interface Props {
  wappId: string
}

export function WappProfileActions({ wappId }: Props) {
  const sharedItems = 0

  const onOpenRoom = async () => {
    const { roomId } = await getWappRoomByWappId(wappId)
    openRoom(roomId)
  }

  return (
    <StyledList>
      <ProfileActionItem Icon={<ChatIcon />} onClick={() => console.log()}>
        {t('profile.wapp.sendMessage')}
      </ProfileActionItem>
      <ProfileActionItem
        Icon={<SharedMediaIcon />}
        onClick={onOpenRoom}
        secondaryText={toLocale(sharedItems)}
        disabled
      >
        {t('profile.common.sharedMedia')}
      </ProfileActionItem>
    </StyledList>
  )
}
